export const MENU_ID_JSM_SETTINGS = 'project/service-desk/settings';

const COMMON_ANALYTICS_ATTRIBUTES = {
	componentType: 'fixedItem',
	level: 1,
};

export const PROJECT_SETTINGS_COMMON_ANALYTICS_ATTRIBUTES = {
	...COMMON_ANALYTICS_ATTRIBUTES,
	actionSubjectId: 'projectSettingsNavigationMenuItem',
};
